<template>
  <div class="opera-messagePush">
    <topNav :title="$t('messagePush_title')"></topNav>
    <div class="whiteBox">
      <div class="switchBox">
        <div class="swithChice">
          <div>{{$t('messagePush_receiveAlert')}}</div>
          <div class="swicthBox">
            <mt-switch v-model="reqMsg.receiveAlert" @change='changeSet'></mt-switch>
          </div>
        </div>
      </div>
      <div class="switchBox">
        <div class="swithChice">
          <div>{{$t('messagePush_receiveSystem')}}</div>
          <div class="swicthBox">
            <mt-switch v-model="reqMsg.receiveSystem" @change='changeSet'></mt-switch>
          </div>
        </div>
      </div>
      <div class="switchBox" v-show="vAndroid">
        <div class="swithChice">
          <div>{{$t('messagePush_startApp')}}</div>
          <div class="swicthBox">
            <mt-switch v-model="reqMsg.startApp" @change='changeSet'></mt-switch>
          </div>
        </div>
      </div>
    </div>
    <div class="whiteBox">
      <div class="switchBox">
        <div class="swithChice">
          <div>{{$t('messagePush_vibration')}}</div>
          <div class="swicthBox">
            <mt-switch v-model="reqMsg.vibration" @change='changeSet'></mt-switch>
          </div>
        </div>
      </div>
      <div class="switchBox">
        <div class="swithChice">
          <div>{{$t('messagePush_voice')}}</div>
          <div class="swicthBox">
            <mt-switch v-model="reqMsg.voice" @change='changeSet'></mt-switch>
          </div>
        </div>
      </div>

    </div>
    <div class="tipBox">{{$t('messagePush_tipBox')}}</div>

  </div>
</template>

<script>
  import {Switch} from "mint-ui";

  export default {
    data() {
      return {
        messageList: {},
        vAndroid: false,
        reqMsg: [
          {
            receiveAlert: "",
            receiveSystem: "",
            startApp: "",
            vibration: "",
            voice: ""
          }
        ]
      };
    },
    mounted() {
      this.getMessage();
      var ua = window.navigator.userAgent;
      if (ua.indexOf("Html5Plus") > 0) {
        if (plus.os.name != "iOS") {
          this.vAndroid = true;
        }
      }
    },
    methods: {
      //获取后台信息
      getMessage() {
        this.$http.post("/mobilepmsapi/sys/getPushInfo").then(res => {
          if (res.data.result == 0) {
            this.messageList = res.data.retVal;
            this.messageList.receiveAlert = this.messageList.receiveAlert == "T";
            this.messageList.receiveSystem = this.messageList.receiveSystem == "T";
            this.messageList.startApp = this.messageList.startApp == "T";
            this.messageList.vibration = this.messageList.vibration == "T";
            this.messageList.voice = this.messageList.voice == "T";
            this.send();
          }
        });
      },
      //修改后台信息，传到后台
      changeSet() {
        this.messageList.receiveAlert =
          this.reqMsg.receiveAlert == true ? "T" : "F";
        this.messageList.receiveSystem =
          this.reqMsg.receiveSystem == true ? "T" : "F";
        this.messageList.startApp = this.reqMsg.startApp == true ? "T" : "F";
        this.messageList.vibration = this.reqMsg.vibration == true ? "T" : "F";
        this.messageList.voice = this.reqMsg.voice == true ? "T" : "F";
        this.$http
          .post("/mobilepmsapi/sys/updatePush", this.messageList)
          .then(res => {
            // console.log('传回数据：'+this.messageList)
          });
      },
      //复制后台取回来的数组
      send() {
        this.reqMsg = Object.assign({}, this.messageList);
      }
    }
  };
</script>

<style lang='less'>
  .opera-messagePush {
    background-color: #f7f8fa;

    .whiteBox {
      width: 100%;
      margin-top: 0.5333rem;
      height: auto;
      background-color: #fff;

      .switchBox {
        border-bottom: 1px solid #f7f8fa;
        width: 93.5%;
        height: 1.3333rem;
        margin: 0 auto;
        padding-top: 1px;

        .swithChice {
          width: 100%;
          height: auto;
          margin-top: 16px;

          div {
            float: left;
            font-size: 0.4267rem;
          }

          .swicthBox {
            float: right;
            margin-top: -0.1867rem;
          }
        }
      }

    }

    .tipBox {
      width: 93.5%;
      color: #999;
      height: 0.8rem;
      line-height: 0.8rem;
      margin: 0 auto;
      font-size: 0.37rem;
    }
  }

  .messagePush .mint-switch-input:checked + .mint-switch-core {
    border-color: #1faa1d;
    background-color: #1faa1d;
  }
</style>



// WEBPACK FOOTER //
// messagePush.vue?1a03d799